var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CreateFieldContext',{ref:"createFieldContext",attrs:{"table":_vm.table,"view":_vm.view,"force-typed":_vm.forcedType,"all-fields-in-table":_vm.allFieldsInTable,"database":_vm.database},on:{"field-created":function($event){return _vm.$emit('field-created', $event)},"field-created-callback-done":_vm.updateInsertedFieldOrder}})
}
var staticRenderFns = []

export { render, staticRenderFns }